import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/settings/admin/grapheme-file-reviewer",
      },
      queries: [],
    }),
    [],
  );
}

export const useGraphemeFileReviewerSettingsPageNavigator = createPageNavigator<void>({
  useNavigator,
});
